// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout_content__QWkJl {
  background-color: var(--color-bg-content);
  min-width: 1200px;
  margin: 91px 0 40px 210px;
  padding: 0px 0px;
}

.Layout_content_no_user__FhFqm {
  background-color: var(--color-bg-content);
  min-width: 1200px;
  margin: 91px 0 40px;
  padding: 0px 0px;
}


/* @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap'); */

p {
  font-family: "Roboto";
  line-height: 1.6;
}

div {
  font-family: "Roboto";
}

h2 {
  font-family: "Roboto";
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/Layout/Layout.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA,iFAAiF;;AAGjF;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".content {\n  background-color: var(--color-bg-content);\n  min-width: 1200px;\n  margin: 91px 0 40px 210px;\n  padding: 0px 0px;\n}\n\n.content_no_user {\n  background-color: var(--color-bg-content);\n  min-width: 1200px;\n  margin: 91px 0 40px;\n  padding: 0px 0px;\n}\n\n\n/* @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap'); */\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap\");\n\np {\n  font-family: \"Roboto\";\n  line-height: 1.6;\n}\n\ndiv {\n  font-family: \"Roboto\";\n}\n\nh2 {\n  font-family: \"Roboto\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `Layout_content__QWkJl`,
	"content_no_user": `Layout_content_no_user__FhFqm`
};
export default ___CSS_LOADER_EXPORT___;
